export const PRODUCT_LPART = [
    {
      sTitle1: "OW-CARBON",
      bTitle: "·低碳空间·",
      sTitle: "低碳技术应用 更环保的发展方式",
      Ltext: ["氢能建筑·直流建筑", " 零碳光伏空调·光伏光热综合利用", " 光储充V2G·地源热泵"]
    },
    {
      sTitle1: "IBERTY",
      bTitle: "·自由人居·",
      sTitle: "九衡科技系统 更高效的人居空间",
      Ltext: ["衡温·衡湿·衡氧", " 衡静·衡洁·衡光", " 衡压·衡智·衡心"]
    },
    {
      sTitle1: "EISURE",
      bTitle: "·舒适社区·",
      sTitle: "绿色健康模拟 更舒适的社区环境",
      Ltext: ["室外光照模拟·室外风环境模拟 ", "室外噪声模拟·室内采光模拟", " 室内眩光模拟·建筑能耗模拟"]
    },
    {
      sTitle1: "INK",
      bTitle: "·交互体验·",
      sTitle: "Ai智慧平台 更轻松的链接体验",
      Ltext: ["一站式生活平台·AI算法物管 ", " 智慧能耗管理·车牌识别闸机", "人脸识别闸机·智能防疫系统"]
    },
    {
      sTitle1: "IVELY",
      bTitle: "·活力服务·",
      sTitle: "多元创新服务 更奇妙多彩的生活",
      Ltext: ["共享邻里空间·共享共创社区  ", "首席生活官·乐活课堂", "  邻里生活节·潮生活文化季"]
    }
  ]
// 
export const PRODUCT_MASTER_LIST = [
    {
      name: "-共享共创社区",
      icon: require("../assets/images/cir.png"),
    },
    {
      name: "-共享邻里空间",
      icon: require("../assets/images/squ.png"),
    },
    {
      name: "-共创社区文化",
      icon: require("../assets/images/hore.png"),
    },
  ];
  //  匠心精筑 探索地产运营新品类
  export const COMPANY_INGEN={
    title:' 匠心精筑 探索地产运营新品类',
    content:'综合运用低碳、科技、新能源等技术，从客户视角出发，构建精准用户的行为模型，以技术为驱动，深度参与城市运营，探索住宅开发、商业运营、物业服务的全新可能。'
  }
  //九衡科技 创领绿色智慧城市新模式
export const COMPANY_SCIENCE={
  title:'九衡科技 创领绿色智慧城市新模式',
  content:"以低碳、科技双轮技术驱动，提供领先的城市发展解决方案与服务。在绿色智造、绿色建筑、绿色能源等领域全面发力，助力城市新发展。"
}
  // 以爱陪伴 营造多彩生活新体系
export const COMPANY_LOVE={
  title:'以爱陪伴 营造多彩生活新体系',
  content:"释放人与空间的价值，演绎生活的奇妙多彩。旨在把所有对品质⽣活的理解，⽤诚信和温度注⼊到空间之中，深度服务⽣活，打造温暖多彩的生活体系。"
}

//
export const PRODUCT_CARD_LIST = [
    {
      name: "首席生活官",
      img: require("../assets/images/img1.png"),
    },
    {
      name: "乐活课堂",
      img: require("../assets/images/img2.png"),
    },
    {
      name: "邻里生活节",
      img: require("../assets/images/img3.png"),
    },
    {
      name: "潮生活文化季",
      img: require("../assets/images/img4.png"),
    },
  ];
  
// 产品卖点
export const PRODUCT_SELLS = [
  {
    name: "衡温",
  },
  {
    name: "衡湿",
  },
  {
    name: "衡氧",
  },
  {
    name: "衡静",
  },
  {
    name: "衡洁",
  },
  {
    name: "衡智",
  },
  {
    name: "衡光",
  },
  {
    name: "衡压",
  },
  {
    name: "衡心",
  },
];  